import { render } from "./AppointmentFlatIcon.vue?vue&type=template&id=3ca6c4b5"
import script from "./AppointmentFlatIcon.vue?vue&type=script&lang=ts"
export * from "./AppointmentFlatIcon.vue?vue&type=script&lang=ts"

import "./AppointmentFlatIcon.vue?vue&type=style&index=0&id=3ca6c4b5&lang=css"
script.render = render

export default script